<template>
	<div class="graph-nd graph-1d">
		<svg :viewBox="'0 0 ' + width + ' ' + height" xmlns="http://www.w3.org/2000/svg">
			<Legend v-bind:width="width"
				v-bind:height="height"
				v-bind:startDate="startDate"
				v-bind:bins="bins.length"
				v-bind:binWidth="binWidth">
			</Legend>

			<g v-for="(bin, index) in bins" :key="index">

				<g v-if="bin.length > 0"
					class="tooltip-trigger"
					@click="showTooltip(bin, ...arguments)"
					@mouseover="showTooltip(bin, ...arguments)"
					@mouseout="hideTooltip">
					<circle
						:cx="centerScaleX(index)"
						:cy="height / 2 - 38"
						r="9"
						style="fill: #ffffff">
					</circle>
					<text :x="centerScaleX(index)"
						  :y="height / 2 - 36"
						  :style="style.labelFont"
						  text-anchor="middle">
						  {{ bin.length }}
					</text>
					<circle :cx="centerScaleX(index)"
							:cy="height / 2 - 23"
							:r="style.pointRadius"
							:fill="style.pointBackgroundColor">
					</circle>
					<circle :cx="centerScaleX(index)"
							:cy="height / 2 - 23"
							:r="style.pointRadius / 2"
							:fill="style.pointColor">
					</circle>
				</g>
			</g>
		</svg>

		<Tooltip v-bind:display="tooltipDisplay" @hover="hoverTooltip">
			<p v-for="(time, i) in tooltipBin" :key="i">
				{{ formatDateTime(time) }}
			</p>
		</Tooltip>
	</div>
</template>

<script>
import Graph from '.'
import Legend from './component/Legend'

export default {
	name: 'graph-1d',
	extends: Graph,

	computed: {
		/**
		 * @function 	bins
		 * @desc 		Bins the data points into day-wide bins for the interval determined by the current scale
		 */
		bins() {
			var bins = []

			for (var t = this.startDate.getTime() ; t <= this.date.getTime() ; t += this.binInterval) {
				bins.push(this.data.filter((time) => (t <= time && time <= t + this.binInterval)))
			}

			return bins
		}
	},
	methods: {
		setScale(scale) {
			this.scale = scale
		},
		centerScaleX(x) {
			return (x + 0.5) * this.width / (this.bins.length + 1)
		}
	},
	components: {
		Legend
	}
}
</script>

<style lang="scss" scoped>
.graph-1d {
	background-color: #ffffff;
}
</style>
